export const getIndexOfLastElement = (elements: any[]) =>
  elements.length > 0 ? elements.length - 1 : 0;
